import React from 'react'
import { SCBM_EMPLOYEE_TYPE_ALLOWED } from '../utils/surveyLiterals';
import {EmployeeView} from '../search/EmployeeView'
import {SupplierView} from '../search/SupplierView'

export const MainView = ({userInfo, authState, hideModal, showModal, abortControllerRef}) => {
    
    return userInfo.userType && SCBM_EMPLOYEE_TYPE_ALLOWED.includes(userInfo.userType) 
    ? <EmployeeView showModal={showModal}  hideModal={hideModal} authState={authState} abortControllerRef={abortControllerRef}/> 
    : <SupplierView userInfo={userInfo}  showModal={showModal} hideModal={hideModal} authState={authState} abortControllerRef={abortControllerRef}/>
}